import type { ComponentType, ReactNode } from 'react';
import type { IconProps } from '../icons';

export interface EmptyStateProps {
  icon: ComponentType<IconProps>;
  title: string;
  text?: string;
  action?: ReactNode;
  tone?: 'default' | 'danger';
}

/**
 * Nothing to show, and why.
 *
 * <p>Three different nothings, and they are not interchangeable: no records yet (offer the
 * primary action), a filter that matched nothing (offer to clear it, never the add button),
 * and a request that failed (offer to retry). The old `.empty` was one grey sentence for all
 * three.</p>
 */
export function EmptyState({ icon: Icon, title, text, action, tone = 'default' }: EmptyStateProps) {
  return (
    <div className="nv-empty" role={tone === 'danger' ? 'alert' : undefined}>
      <span className={tone === 'danger' ? 'nv-empty__icon nv-empty__icon--danger' : 'nv-empty__icon'}>
        <Icon size={24} />
      </span>
      <h2 className="nv-h3">{title}</h2>
      {text ? <p className="nv-muted nv-empty__text">{text}</p> : null}
      {action ? <div className="nv-empty__action">{action}</div> : null}
    </div>
  );
}
